module.exports = __webpack_public_path__ + "img/form-icon.44997b5a.svg";